import { KYCStatus } from "@foxone/api/src/models/account";
import { Colors } from "@/types";

export enum KYCShowsStatus {
  NOTYET = "notyet",
  PROCESSING = "processing",
  REJECTED = "reject",
  APPROVED = "approved"
}

export const KYCStatusMeta = {
  [KYCShowsStatus.NOTYET]: {
    status: KYCShowsStatus.NOTYET,
    text: "kyc.status.notyet",
    color: Colors.WARNING
  },
  [KYCShowsStatus.PROCESSING]: {
    status: KYCShowsStatus.PROCESSING,
    text: "kyc.status.processing",
    color: Colors.WARNING
  },
  [KYCShowsStatus.REJECTED]: {
    status: KYCShowsStatus.REJECTED,
    text: "kyc.status.reject",
    color: Colors.RED
  },
  [KYCShowsStatus.APPROVED]: {
    status: KYCShowsStatus.APPROVED,
    text: "kyc.status.approved",
    color: Colors.GREEN
  }
};

export function getKYCStatusMeta(status: KYCStatus) {
  if (status === KYCStatus.UNKONWN) {
    return KYCStatusMeta[KYCShowsStatus.NOTYET];
  } else if (status === KYCStatus.PROCESSING) {
    return KYCStatusMeta[KYCShowsStatus.PROCESSING];
  } else if (status === KYCStatus.REJECTED) {
    return KYCStatusMeta[KYCShowsStatus.REJECTED];
  } else if (status === KYCStatus.APPROVED) {
    return KYCStatusMeta[KYCShowsStatus.APPROVED];
  } else {
    return KYCStatusMeta[KYCShowsStatus.NOTYET];
  }
}
